import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import { setLocation } from '../reducers/mapRefs';

// Simulate a 'down arrow' keypress when the enter key is pressed in the Autocomplete widget
// https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter
// See "A working answer for 2020"

const enableEnterKey = (input) => {
  const originalAddEventListener = input.addEventListener;

  const addEventListenerWrapper = (type, listener) => {
    let newListener = listener;

    if (type === 'keydown') {
      newListener = (event) => {
        setTimeout(() => {
          const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;

          if (event.key === 'Enter' && !suggestionSelected) {
            const e = new KeyboardEvent('keydown', {
              key: 'ArrowDown',
              code: 'ArrowDown',
              keyCode: 40,
            });

            listener.apply(input, [e]);
          }

          listener.apply(input, [event]);
        }, 250);
      };
    }

    originalAddEventListener.apply(input, [type, newListener]);
  };

  input.addEventListener = addEventListenerWrapper;
};

export default function Geocoder() {
  const mapDiv = useSelector((state) => state.mapRefs.mapDiv);
  const [, setAutocomplete] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const element = document.getElementById('geocoder');

    if (!element) {
      return;
    }

    element.addEventListener('keyup', () => {
      if (element.textContent.length === 0) {
        dispatch(setLocation({}));
      }
    });

    const autocomplete = new window.google.maps.places.Autocomplete(element, {
      fields: ['formatted_address', 'geometry'],
      bounds: {
        north: 39.33,
        south: 38.97,
        east: -84.15,
        west: -84.87,
      },
      strictBounds: true,
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (place && place.geometry) {
        const location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          address: place.formatted_address,
        };
        dispatch(setLocation(location));
      }
    });

    enableEnterKey(element);
    setAutocomplete(autocomplete);
  }, [mapDiv]);

  if (!mapDiv) {
    return '';
  }

  return (
    <TextField
      sx={{
        width: 240,
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'white',
          },
          '&:hover fieldset': {
            borderColor: 'white',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white',
          },
        } }}
      label="Address "
      InputProps={{ id: 'geocoder', style: { fontSize: '0.875rem', color: 'white' } }}
      InputLabelProps={{ style: { color: 'white' } }}
      variant="outlined"
      size="small"
    />
  );
}
